module.exports = __webpack_public_path__ + "img/description1.ce95a73c.jpg";